


































































































































































































































































































































































































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class CoinRotateTopIcon extends Vue {
  @Prop({ default: '129' }) readonly width?: string;
  @Prop({ default: '99' }) readonly height?: string;
}
